export const getNavInfo = (resourceid: string) => {
  return `SELECT ?next ?prev ?parent ?title ?longTitle
  WHERE {
    <${resourceid}> <http://purl.org/dc/elements/1.1/title> ?title .
    <${resourceid}> <http://scta.info/property/longTitle> ?longTitle .
    OPTIONAL{
      <${resourceid}> <http://scta.info/property/next> ?next .
      }
    OPTIONAL{
      <${resourceid}> <http://scta.info/property/previous> ?prev .
      }
    OPTIONAL{
      <${resourceid}> <http://purl.org/dc/terms/isPartOf> ?parent .
      }
  }`
}